import { Account } from "callable-data-objects";
import React from "react";
import { Container, Divider, Header } from "semantic-ui-react";
import AccountSetting from "./AccountSetting";

type AccountLocaleProps = {
  account: Account;
};

function AccountChannels({ account }: AccountLocaleProps) {
  return (
    <Container>
      <Header as='h3'>Update Concurrency</Header>
      <Divider />
      <AccountSetting
        account={account}
        name='SoftwareChannels'
        type='number'
        min={0}
        max={100}
        label='Max Call Concurrency'
      />
    </Container>
  );
}

export default AccountChannels;
